

function showModal(_target){
  $('#js-modal-bg').fadeIn(150);
  setTimeout(function(){
    $(_target).addClass('show');
    setTimeout(function(){
      $(_target).addClass('show2');
    },10);
  },150);

  if($(_target).hasClass('js-lazy-images')){
    $(_target).find('.lazy-item img').each(function(){
      const src = $(this).data('src');
      $(this).attr('src',src);
    })
  }

}

function hideModal(){
  // $('.modal.show').fadeOut(150);
  $('#js-modal-bg').fadeOut(150);
  $('.modal').removeClass('show2');
  $('.modal').removeClass('show');
  // setTimeout(function(){
  //   $(_target).removeClass('show');
  // },150);
}


$(document).on("click", ".js-modal-close", hideModal);
$(document).on("click", ".js-show-modal", function(){
  const target = $(this).data('target');
  showModal(target);
});

function touchScrollCancel(e) {
  if (e.type == "touchmove") {
      e.preventDefault();
  }
}








// $('#js-form-onetime').on('submit',function(){
//   $('#js-form-onetime').fadeOut(150);
//   setTimeout(function(){
//     $('#js-form-login').fadeIn(150);
//   },200);
//   return false;
// });
